import { SearchFilter } from "../invoices/invoiceAPI";

export const TALENT_FILTERS_LOCAL_STORAGE = "talentFilters";
export const TALENT_QUICK_FILTER_LOCAL_STORAGE = "talentQuickFilter";

export const TALENT_DEFAULT_FILTERS: SearchFilter[] = [
  { name: "status", value: [] },
  { name: "hrRepresentative", value: [] },
];
